/**
 * Size Recs Queries
 */

import gql from 'graphql-tag'

export const getSizeRecRequestsQuery = gql`
  query getSizeRecItem($id: Int){
    sizeRequestItem: getSizeRecItem(id: $id) {
      id
      sizeRecId: size_rec_id
      productId: product_id
      productName: product_name
      shortDescription: short_description
      status
      fitPreference: fit_preference
      fitNote: fit_note
      recommenderNote: recommender_note
      createdAt: created_at
      role
      profileOwner: profile_owner
      fullName: customer_name
      height
      weight
      unit
      upper_arm_length
      outseam
      gender
      chest
      waist
      low_hips
      neck
      inside_leg_height
      gender_rec
      style_rec
      size_recommendation
      length_name
      length_rec
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecDetails/data.ts